export interface RoadmapNodeBase {
    id: string;
    label: string;
}

export interface RoadmapChildNode extends RoadmapNodeBase {
    children?: RoadmapChildNode[];
    description?: string;
    videoLink?: string;
    tips?: string[];
}

export interface RoadmapStructure {
    nodes: RoadmapChildNode[];
}

// Main roadmap data
export const roadmapData: RoadmapStructure = {
    "nodes": [
        {
            id: "1",
            label: "מבוא – הכנה לחיפוש עבודה",
            description: "השלבים הראשוניים בתהליך של חיפוש עבודה והבנת התהליך הכולל",
            children: [
                {
                    id: "1.1",
                    label: "הבנת התהליך הכללי",
                    description: "הבנת התהליך הכולל של חיפוש עבודה, מהשלבים הראשונים ועד קבלת הצעות",
                    tips: [
                        "חיפוש עבודה זה תהליך ארוך ומורכב, ועלינו להיות מוכנים לזה!",
                        "הכירו את השלבים העיקריים: כתיבת קורות חיים, בניית פרופיל מקצועי, חיפוש והגשת מועמדויות, הכנה לראיונות",
                        "צפו לאתגרים לאורך הדרך והיו מוכנים להמשיך בהתמדה"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "1.2",
                    label: "תכנון לוחות זמנים ותרחישים",
                    description: "בניית תוכנית זמן ריאלית לחיפוש עבודה והתמודדות עם תרחישים אפשריים",
                    tips: [
                        "תכננו לוח זמנים יומי ושבועי הכולל חיפוש עבודה, נטוורקינג ולמידה",
                        "צפו לתקופות של חוסר תגובה ודחיות כחלק טבעי מהתהליך"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "1.3",
                    label: "שמירה על מיקוד וניהול זמן",
                    description: "טכניקות לשמירה על מוטיבציה, ניהול זמן אישי והתקדמות מתמדת בחיפוש עבודה",
                    tips: [
                        "קבעו יעדים ברורים לכל שבוע ויום",
                        "בצעו מעקב אחרי התקדמות ונתחו מה עובד ומה לא"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            id: "2",
            label: "שלב 1 – חיפוש עבודה והבנת השוק",
            description: "הבנת שוק העבודה, זיהוי מגמות, וניהול נכון של הזמן בתהליך החיפוש",
            children: [
                {
                    id: "2.1",
                    label: "ניהול זמן אפקטיבי",
                    description: "תכנון וניהול זמן נכון במהלך חיפוש עבודה להגברת יעילות ומניעת שחיקה",
                    tips: [
                        "הקדישו 4-6 שעות יומיות לפעילויות חיפוש עבודה ולמידה",
                        "חלקו את הזמן בין נטוורקינג, הגשת מועמדויות, ולמידת תחומים רלוונטיים"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "2.2",
                    label: "הבנת תרחישים ותהליך חיפוש עבודה",
                    description: "הכרת תרחישים אפשריים והיערכות נפשית לתהליך הכולל דחיות, המתנות ואי-ודאות",
                    tips: [
                        "הבינו כי קצב קבלת התשובות משתנה מחברה לחברה",
                        "הכינו עצמכם נפשית לתקופות של חוסר תגובה ולמדו להמשיך בתהליך בביטחון"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "2.3",
                    label: "שמירה על מיקוד ומוטיבציה",
                    description: "אסטרטגיות לשמירה על מיקוד, חוסן נפשי, ומניעת ירידה במוטיבציה במהלך החיפוש",
                    tips: [
                        "קבעו יעדים שבועיים ומדדו את ההתקדמות",
                        "חגגו הצלחות קטנות לאורך הדרך כדי לשמור על דרייב גבוה"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            id: "3",
            label: "שלב 2 – יצירת תדמית מקצועית",
            description: "בניית נוכחות מקצועית שמושכת מעסיקים, מעבירה מסר ברור, ומבליטה את הערך שלך כמועמד",
            children: [
                {
                    id: "3.1",
                    label: "בניית קורות חיים",
                    description: "קורות החיים הם כרטיס הביקור שלך – בפרט כשאין ניסיון. הם מציגים את הערך שאתה מביא, היכולות והכוונות המקצועיות שלך",
                    tips: [
                        "בנה מסמך ברור, תמציתי וללא שגיאות",
                        "שקף את הכישורים וההישגים שלך, גם אם לא מעבודה רשמית (למשל פרויקטים אישיים, קורסים)",
                        "התאם את הקו״ח לכל משרה – אין דבר כזה 'קו״ח אחד לכולם'"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "3.2",
                    label: "בניית פרופיל LinkedIn",
                    description: "LinkedIn היא רשת מקצועית קריטית. היא מקור עיקרי לגיוס עובדים, יצירת קשרים עם מגייסים, ובניית תדמית דיגיטלית אמינה",
                    tips: [
                        "שמור על פרופיל עדכני עם תמונה מקצועית, כותרת ותיאור אישי איכותי",
                        "הצג את הכישורים שלך, פרויקטים, הישגים וקורסים רלוונטיים",
                        "השתמש במילות מפתח רלוונטיות בתחום שלך כדי להופיע בחיפושים"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "3.3",
                    label: "Networking",
                    description: "נטוורקינג הוא אחד הכלים הכי חזקים למציאת עבודה. הוא מאפשר להגיע להזדמנויות שלא מפורסמות בכלל, וליצור קשרים עם אנשים מהתחום",
                    tips: [
                        "פנה לאנשים שאתה מעריך – בלי להתבייש",
                        "אל תבקש עבודה מיד – קודם תציע עניין, שאלות או שיתוף",
                        "שמור על קשר לאורך זמן – בנה אמון, לא רק מטרה רגעית"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            id: "4",
            label: "שלב 3 – פרויקט אישי מקצועי",
            description: "פיתוח פרויקט אישי הוא דרך להראות יוזמה, יכולות טכניות, ויכולת ללמוד לבד. זה כרטיס כניסה לעולם האמיתי עבור מועמדים ללא ניסיון",
            children: [
                {
                    id: "4.1",
                    label: "איך לבחור פרויקט נכון",
                    description: "בחירת פרויקט אישי צריכה לשלב עניין אישי עם ערך מקצועי – משהו שמעניין אותך אבל גם רלוונטי לשוק העבודה",
                    tips: [
                        "פתור בעיה אמיתית שאתה נתקל בה ביום-יום",
                        "בחר נושא שמעניין אותך – כך תתמיד בו",
                        "קודם כל תשיקעו בתכנון!"

                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "4.2",
                    label: "ניהול והצגת פרויקט ב-GitHub",
                    description: "הצגת הפרויקט שלך בצורה מקצועית ב-GitHub היא חלק מהשיווק שלך. זה הרושם הראשוני שתעשה על מגייסים ומפתחים אחרים",
                    tips: [
                        "השתמש ב-README מפורט – תאר את הבעיה, הפתרון והטכנולוגיות",
                        "צרף תמונות, דמו, או וידאו קצר",
                        "חלק את הקוד לתיקיות מסודרות והקפד על תיעוד"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "4.3",
                    label: "דוגמאות לפרויקטים - לקבלת כיוון כללי",
                    description: "כדי להבין מה הופך פרויקט לטוב, כדאי לראות דוגמאות חיות של פרויקטים ברמה גבוהה, כמו roadm.sh – שמציג Roadmap אינטראקטיבי",
                    tips: [
                        "בחנו פרויקטים ב-Product Hunt ו-GitHub Trending",
                        "נסו ליצור משהו עם UI ברור וערך מוסף – כמו אתר מידע, כלי ניתוח או אפליקציה שימושית",
                        "נסו להכניס אלמנט של טכנולוגיה חדשה שתרצו ללמוד"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            "id": "5",
            "label": "שלב 4 - חיפוש משרות ושליחת קורות חיים",
            "description": "תהליך אסטרטגי למציאת משרות והגשת מועמדות",
            "tips": ["התאם את הפרופיל שלך לדרישות המשרה", "עקוב אחרי כל הגשה"],
            "children": [
                {
                    "id": "5.1",
                    "label": "איפה לחפש משרות",
                    "description": "מקורות לחיפוש משרות",
                    "tips": [
                        "השתמשו במגוון פלטפורמות: אתרי דרושים, לינקדאין, קבוצות פייסבוק, דיסקורד, טלגרם ואתרים ייעודיים בתחום שלכם",
                        "בדקו גם דפים רשמיים של חברות, במיוחד אם יש לכם חברות יעד",
                        "חפשו משרות שמציינות 'Entry Level' או 'Student Position' אם אתם בתחילת הדרך"
                    ],
                    "videoLink": "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    "id": "5.2",
                    "label": "איך להגיש קורות חיים נכון",
                    "description": "טכניקות להגשת קו\"ח",
                    "tips": [
                        "וודאו שהקו\"ח מותאמים למשרה – הדגישו ניסיון, כישורים ומילים מתוך הדרישות",
                        "שלחו בפורמט PDF, אלא אם מצוין אחרת",
                        "וודאו שכל הקישורים (GitHub, LinkedIn, פרויקטים) פועלים כראוי"
                    ],
                    "videoLink": "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    "id": "5.3",
                    "label": "ניהול ומעקב אחרי הגשות",
                    "description": "מעקב אחר הגשות ותגובות",
                    "tips": [
                        "נהלו מעקב בגיליון אקסל או אפליקציית ניהול משימות כמו Notion או Trello",
                        "רשמו את שם החברה, תאריך הגשה, תיאור המשרה וסטטוס (הוגש / ממתין / ראיון)",
                        "קבעו תזכורות לשליחת מעקב אחרי שבוע-שבועיים אם אין תגובה"
                    ],
                    "videoLink": "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    "id": "5.4",
                    "label": "איך להתמודד עם דחיות",
                    "description": "התמודדות אפקטיבית עם דחיות",
                    "tips": [
                        "התייחסו לדחייה כהזדמנות לשיפור – נסו להבין מה לא עבד",
                        "אם ניתן, בקשו פידבק מהמגייס או המראיין (לא תמיד אפשרי, אבל שווה לנסות)",
                        "שמרו על מוטיבציה – כל ראיון שנכשל מלמד אתכם משהו שיעזור להצליח בבא"
                    ],
                    "videoLink": "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            "id": "6",
            "label": "שלב 5 – הכנה טכנית לראיונות עבודה",
            "description": "פיתוח יכולות טכניות לקראת ראיונות",
            "tips": ["תרגל שאלות קודינג באופן יומי", "הבן את הדרישות הטכניות לכל תפקיד"],
            "children": [
                {
                    id: "6.1",
                    label: "בחירת שפת תכנות",
                    description: "איך לבחור שפת תכנות לראיונות עבודה ולהתמיד בה לאורך תהליך ההכנה",
                    tips: [
                        "בחרו שפה שאתם מרגישים בה נוח – לרוב פייתון היא השפה הממולצת",
                        "הקפידו לתרגל איתה את כל סוגי הבעיות (מחרוזות, מערכים, גרפים)",
                        "למדו תחביר בסיסי, טיפוסי נתונים, פונקציות ועבודה עם מבני נתונים מובנים"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "6.2",
                    label: "ידע טכני נדרש – מבני נתונים ואלגוריתמים",
                    description: "נושאים מרכזיים שחשוב להכיר כדי להצליח בראיונות קידוד",
                    tips: [
                        "הבינו איך פועלים מבני נתונים בסיסיים: מערך, רשימה מקושרת, סטאק, קיו, עץ, גרף",
                        "למדו ותרגלו אלגוריתמים מרכזיים: חיפוש בינארי, מיון, רקורסיה, BFS/DFS, דינמיות",
                        "שימו לב גם למורכבות זמן (Big-O) וליעילות פתרון"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "6.3",
                    label: "תרגול עם LeetCode ו-סימולציות",
                    description: "איך להשתמש ב-LeetCode בצורה חכמה ולתרגל כמו בראיון אמיתי",
                    tips: [
                        "התחילו עם בעיות קלות לפי נושאים כדי לבנות ביטחון",
                        "עברו לבעיות בינוניות כשמרגישים מוכנים – לא לדלג יותר מדי מהר",
                        "תרגלו עם טיימר ונסחו את המחשבה בקול, כמו בראיון אמיתי"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "6.4",
                    label: "תכנית תרגול ב-LeetCode",
                    description: "מבנה תרגול מסודר לפי נושאים, דרגות קושי והתקדמות הדרגתית שיכין אותך לראיונות אמיתיים",
                    tips: [
                        "Neetcode.io/roadmap הוא מקור מצוין לתרגול מסודר",
                        "התחילו מ-Easy, ואז עברו ל-Medium. את Hard תשמרו לסוף או לפי צורך",
                        "בנו לעצמכם מסלול תרגול יומי/שבועי, עם מטרות ברורות כמו '5 שאלות Arrays השבוע'",
                        "חזרו לשאלות שנכשלתם בהן – זה מה שמפתח אתכם הכי הרבה"
                    ],
                    videoLink: "https://www.neetcode.io/roadmap"
                },
                {
                    id: "6.5",
                    label: "מקורות נוספים ללמידה",
                    description: "אתרים, ספרים, קורסים וסימולציות שיכולים לעזור לך ללמוד בצורה עצמאית",
                    tips: [
                        "ספר מומלץ: Cracking the Coding Interview",
                        "קורסים: NeetCode (חינמי), AlgoExpert (בתשלום), Udemy",
                        "בצעו סימולציות עם חברים או באתרים כמו Pramp ו-Interviewing.io"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            id: "7",
            label: "שלב 6 – הכנה לראיונות טכניים",
            description: "הבנה מעמיקה של מבנה הראיונות, שיפור יכולת ההצגה העצמית, ושימוש בשיטות אפקטיביות להצגת ניסיון ומיומנויות",
            children: [
                {
                    id: "7.1",
                    label: "איך להציג את עצמך נכון",
                    description: "טכניקות להצגה עצמית מקצועית שתופסת את תשומת הלב בפתיחת ראיון",
                    tips: [
                        "בנו הצגה עצמית של 1-2 דקות – כולל רקע, תחום התמחות עיקרי ומטרות",
                        "התאימו את הפיץ' לסוג החברה והתפקיד",
                        "שמרו על ביטחון, חיוך ודיבור רהוט"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "7.2",
                    label: "שימוש בשיטת STAR",
                    description: "הצגת סיפורים מקצועיים דרך פורמט ברור: מצב, משימה, פעולה, תוצאה",
                    tips: [
                        "הכינו 3-5 דוגמאות מוכנות מראש לפי STAR",
                        "התמקדו בבעיה, פעולה אישית, ותוצאה מדידה (כגון שיפור בביצועים, חיסכון בזמן וכו')",
                        "שמרו על דוגמאות קצרות וממוקדות"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "7.3",
                    label: "מבנה ראיון טכני",
                    description: "מה מצופה בראיונות טכניים: קידוד, עיצוב מערכות, ושאלות התנהגותיות",
                    tips: [
                        "הבינו את סוגי הראיונות: קידוד בזמן אמת, Design, behavioral",
                        "בכל פתרון תעדפו להסביר את החשיבה בקול",
                        "אם נתקעים – חשוב להראות איך מתקדמים, לא רק את התוצאה הסופית"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "7.4",
                    label: "ניהול זמן בראיון",
                    description: "איך לחלק נכון את הזמן במהלך שאלות טכניות ותשובות בראיון",
                    tips: [
                        "בפתרון קידוד – השקיעו 2-3 דקות בהבנת השאלה לפני כתיבה",
                        "חלקו את הזמן: הבנה → פתרון → בדיקה → שיפור",
                        "במידה ונגמר הזמן – תארו איך הייתם ממשיכים אם הייתה לכם עוד חצי שעה"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "7.5",
                    label: "שיטה לפתרון בעיות בצורה ממוקדת",
                    description: "תהליך עבודה מסודר לפתרון בעיות טכניות בראיון שמדגים הבנה, סדר מחשבתי ויכולת שיפור פתרונות",
                    tips: [
                        "התחילו מהבנת הבעיה: קראו בעיון ונסחו במילים שלכם מה נדרש",
                        "תנו הסבר כללי: חזרו בקול רם על הבקשה כדי לוודא הבנה משותפת עם המראיין",
                        "הריצו דוגמה ידנית פשוטה כדי לראות את ההתנהגות הצפויה",
                        "כתבו פתרון נאיבי ראשון גם אם לא אופטימלי – העיקר להתחיל",
                        "בצעו שיפור הדרגתי לפתרון: ייעול זמן ריצה, זיכרון, קריאות קוד"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        },
        {
            id: "8",
            label: "שלב 7 – סיום – טיפים ומשימות להמשך",
            description: "סיכום התהליך כולו, בניית המשך הדרך האישית, והתמקדות בשיפור מתמיד גם אחרי קבלת עבודה",
            children: [
                {
                    id: "8.1",
                    label: "טיפים להצגת יכולות",
                    description: "איך להמשיך להציג את היכולות שלך גם אחרי קבלת עבודה או במהלך המשך החיפוש",
                    tips: [
                        "עדכן את ה-LinkedIn וה-GitHub שלך אחרי כל התקדמות או הישג",
                        "שתף פרויקטים אישיים ופוסטים מקצועיים – תישאר בתודעה",
                        "דאג להדגיש לא רק טכנולוגיות אלא גם יכולות רכות (Soft Skills)"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "8.2",
                    label: "הצבת יעדים ומשימות להמשך",
                    description: "תכנון נכון של היעדים לטווח קצר וארוך כדי להבטיח המשך צמיחה מקצועית",
                    tips: [
                        "הציבו יעד חודשי קטן – פרויקט אישי חדש, סיום קורס קצר, מעבר על X שאלות LeetCode",
                        "בנו תוכנית לימודים עצמית מותאמת ללו״ז שלכם",
                        "התחייבו ל-Weekly Retrospective – ניתוח שבועי של מה עבד ומה לשפר"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "8.3",
                    label: "התחלת תהליך הגשת מועמדות",
                    description: "צעדים ראשונים חכמים להתחלת תהליך חיפוש עבודה או שיפור משרות קיימות",
                    tips: [
                        "התחילו בהגשות למשרות שאתם הכי מתרגשים מהן, אבל גם עם מעט Backup Positions",
                        "שמרו טבלה עם כל משרה – כדי לשלוט בקצב ולהבין מה עובד",
                        "בצעו סימולציות קצרות לפני ראיונות כדי לשמור על כושר"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                },
                {
                    id: "8.4",
                    label: "שיפור מתמיד ולמידה אחרי ראיונות",
                    description: "איך להפוך כל ראיון או חיפוש למקפצה ללמידה וצמיחה",
                    tips: [
                        "רשמו אחרי כל ראיון מה הלך טוב ומה פחות",
                        "בקשו פידבק בצורה ישירה ומכבדת",
                        "עשו ניתוח עצמי: אילו נושאים דרושים חיזוק?"
                    ],
                    videoLink: "https://www.univeli.com/path-player?courseid=prepare-me-for-high-tech&unit=67921accd612b3078a0925e5Unit"
                }
            ]
        }
    ]
};